import React from 'react';
import type { IconProps } from '../types';

export const Icon3D = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* <title>info-3d</title> */}
    <g
      id="info-3d"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Background"
        x="0"
        y="0"
        width="28"
        height="28"
        fill="transparent"
      ></rect>

      {/* Perspective Base */}
      <polygon
        id="Perspective-Base"
        fill="currentColor"
        fillOpacity="0.1"
        points="4 20 14 4 24 20"
      ></polygon>

      {/* Left Face */}
      <polygon
        id="Left-Face"
        fill="currentColor"
        fillOpacity="0.2"
        points="4 20 14 12 14 4"
      ></polygon>

      {/* Right Face */}
      <polygon
        id="Right-Face"
        fill="currentColor"
        fillOpacity="0.15"
        points="14 4 14 12 24 20"
      ></polygon>

      {/* Grid */}
      <g
        id="Grid"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeDasharray="2,2"
        strokeOpacity="0.5"
      >
        <line
          x1="4"
          y1="20"
          x2="14"
          y2="4"
        ></line>
        <line
          x1="14"
          y1="4"
          x2="24"
          y2="20"
        ></line>
        <line
          x1="8"
          y1="20"
          x2="14"
          y2="12"
        ></line>
        <line
          x1="14"
          y1="12"
          x2="20"
          y2="20"
        ></line>
      </g>

      {/* Highlight Render Lines */}
      <g
        id="Render-Lines"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      >
        <line
          x1="4"
          y1="20"
          x2="14"
          y2="12"
        ></line>
        <line
          x1="14"
          y1="12"
          x2="24"
          y2="20"
        ></line>
      </g>

      {/* Render Highlight Circle */}
      <circle
        id="Render-Circle"
        fill="currentColor"
        cx="14"
        cy="12"
        r="1.5"
      ></circle>
    </g>
  </svg>
);

export default Icon3D;
